










































import {
    Component,
    Prop,
    Vue
} from 'vue-property-decorator';
import {
    pageDataType
} from "../../types";
import {
    HOST
} from "../../global";
import {
    TweenMax,
    TimelineLite,
    Power3,
    Power4,
    Power2,
    TimelineMax,
} from 'gsap';
import ScrollMagic from "scrollmagic";
import gsap from 'scrollmagic';
@Component({
    name: "AwardBlock",
}) export default class AwardBlock extends Vue {
    @Prop() readonly compData!: any;
    public HOST: string = HOST;

    public awardAnim() {

        //text timeline

        const awdtext = new TimelineMax()
           
            .staggerFrom('.awdtitle-block .title-color', .6, {
                yPercent: 60,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, .01)
            .staggerFrom('.awdtitle-block h2', .6, {
                yPercent: 60,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, .01, '-=.4')
            .staggerFrom('.awdtitle-block p', .6, {
                yPercent: 60,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.01, '-=.5')
            .staggerFrom('.awdtext-block .btn-link', .6, {
                yPercent: 60,
                autoAlpha: 0,
                ease: Power2.easeOut,
                clearProps: 'all'
            }, 0.01, '-=.5')

        const controller = new ScrollMagic.Controller();
        const scene = new ScrollMagic.Scene({
                triggerElement: ".awdtext-cont",
                reverse: false,
            })
            .setTween(awdtext)
            .addTo(controller);
        // image 
        const adimg = new TimelineMax()
            .to('.aimg-wrap', .01, {
                overflow: 'hidden'
            })
            .staggerFrom('.awd-img img', 1, {
                width: '40%',
                scale: 1.65,
                xPercent: -60,
                autoAlpha: 0,
                ease: Power2.easeInOut,
                clearProps: 'all'
            }, .01)

            .to('.aimg-wrap', .01, {
                clearProps: 'all'
            })
        const controller2 = new ScrollMagic.Controller();
        const scene2 = new ScrollMagic.Scene({
                triggerElement: ".awd-img",
                reverse: false,
            })
            .setTween(adimg)
            .addTo(controller2);

    }

    public mounted() {
        if (window.matchMedia("(min-width: 1025px)").matches) {
            this.awardAnim();
        }

    }
}
